import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Mediaclip } from '../../../interfaces/mediaclip';
import { SapiService } from '../../../services/sapi.service';

@Component({
	selector: 'playout-details-viewpage',
	templateUrl: './playout-details-viewpage.component.html',
	styleUrls: ['./playout-details-viewpage.component.scss']
})

export class PlayoutDetailsViewpageComponent implements OnInit, OnDestroy {

	@Input() playout: any;
	@Input() form: NgForm;
	@Input() usedColors: string[];

	@Output() updateViewpage: EventEmitter<any> = new EventEmitter();

	viewpageLogoPositions: any = [
		['top left', 'top right'],
		['botton left', 'bottom right']
	];
	justUploaded: any = {};
	logoFilterSet = [{
		filters: [{
			type: 'mediaclip',
			field: 'mediatype',
			operator: 'is',
			value: 'image'
		}]
	}];

	constructor(protected sapiService: SapiService
	) {
	}

	ngOnInit() {
		if (this.playout) {
			this.updateViewpagePreview(true);
		}
	}

	ngOnDestroy() { }

	updateViewpagePreview(initial: any) {
		let copyPlayout = { ... this.playout } as any;
		delete copyPlayout.id;

		this.sapiService.postUrl(('/playout?preview=true'), copyPlayout).subscribe((response: any) => {
			copyPlayout = response;
			this.updateViewpage.emit({ code: response.previewCode, initial: !!initial });
		});
	}

	changedEntityId() {
		this.form.form.markAsDirty();
	}

	onLogoCreated(mediaclip: Mediaclip, fieldName: string) {
		this.justUploaded[fieldName] = true;
		this.playout.viewpage_backgroundClipId = mediaclip.id;
		setTimeout(() => {
			this.justUploaded[fieldName] = false;
		}, 5000);
	}

	log(a: any) {
		console.warn('log', a);
	}
}
